// extracted by mini-css-extract-plugin
module.exports = {"tabRouterLayout":"TabRouterLayout_tabRouterLayout__8Kg_u"};